import { ActionCableComponentsMixin } from 'src/modules/websocket_module.js';
import { broadcasting } from 'src/modules/services/ai-service';

export default {
  mixins: [ActionCableComponentsMixin],
  data: function() {
    return {
      connection: 0,
      readyCount: 0
    }
  },
  methods: {
    initMixerSubscription() {
      this.subscribe(
        { channel: "ListenerChannel", room: "interview_mixer" },
        { 
          connected: () => console.log("%cMIXER READY", "background-color: yellow;"),
          received: this.handleMixerMessage
        }
      );
    },
    handleMixerMessage(data) {
      switch (data.type) {
        case "connection":
          this.connection++;
          console.log("%cMIXER", "background-color: yellow;", "new connection. Total:", this.connection, data);
          this.sendMixerMessage("confirm-connection", { connectionId: data.payload?.connectionId});
          break;
        case "disconnected":
          if (this.connection>0) {
            this.connection--;
          }
          console.log("%cMIXER", "background-color: yellow;", "connection closed. Total:", this.connection);
          break;
        case "video-ready":
          this.readyCount++;
          if (this.readyCount === this.connection) {
            console.log("%cMIXER", "background-color: yellow;", "All video_ready");
            this.sendMixerMessage("play-video");
            this.readyCount = 0;
          } else {
            console.log("%cMIXER", "background-color: yellow;", "new video_ready. Total:", this.readyCount, "Waiting:", this.connection-this.readyCount);
          }
          break;
        case "play-video":
          this.playVideo();
          break;
        default:
          break;
      }
    },
    sendMixerMessage(type, payload) {
      console.log("%cMIXER", "background-color: yellow;", "Send message:", type);
      broadcasting({ room: "interview_mixer", type, payload: JSON.stringify(payload)});
    },
  }
}